import React from 'react';

import ExperimentsListing from '@/features/experiment/listing/experiments-listing';

const ExperimentsPage: React.FC = () => <ExperimentsListing />;

export default ExperimentsPage;
